import { createSlice, type PayloadAction } from '@reduxjs/toolkit';
import type { ContratosState, ContratoTenant } from '../../types/contratosTenant';
import {
  fetchContratosByTenant,
  vincularProduto,
  editarContrato,
  suspenderContrato,
  reativarContrato,
  encerrarContrato,
  excluirContrato,
} from './actions';

const initialState: ContratosState = {
  contratos: [],
  loading: false,
  saving: false,
  error: null,
  currentRequestId: null,
};

const contratosTenantSlice = createSlice({
  name: 'contratosTenant',
  initialState,
  reducers: {
    clearError: (state) => {
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchContratosByTenant.pending, (state, action) => {
        state.loading = true;
        state.error = null;
        state.contratos = [];
        state.currentRequestId = action.meta.requestId;
      })
      .addCase(fetchContratosByTenant.fulfilled, (state, action) => {
        if (action.meta.requestId !== state.currentRequestId) return;
        state.loading = false;
        state.contratos = action.payload;
      })
      .addCase(fetchContratosByTenant.rejected, (state, action) => {
        if (action.meta.requestId !== state.currentRequestId) return;
        state.loading = false;
        state.error = (action.payload as string) ?? 'Erro ao carregar contratos';
      })

      .addCase(vincularProduto.pending, (state) => {
        state.saving = true;
        state.error = null;
      })
      .addCase(vincularProduto.fulfilled, (state, action: PayloadAction<ContratoTenant>) => {
        state.saving = false;
        state.contratos = [action.payload, ...state.contratos];
      })
      .addCase(vincularProduto.rejected, (state, action) => {
        state.saving = false;
        state.error = (action.payload as string) ?? 'Erro ao vincular produto';
      })

      .addCase(editarContrato.pending, (state) => {
        state.saving = true;
        state.error = null;
      })
      .addCase(editarContrato.fulfilled, (state, action: PayloadAction<ContratoTenant>) => {
        state.saving = false;
        state.contratos = state.contratos.map((c) =>
          c.id === action.payload.id ? action.payload : c,
        );
      })
      .addCase(editarContrato.rejected, (state, action) => {
        state.saving = false;
        state.error = (action.payload as string) ?? 'Erro ao editar contrato';
      })

      .addCase(suspenderContrato.pending, (state) => {
        state.saving = true;
        state.error = null;
      })
      .addCase(suspenderContrato.fulfilled, (state, action: PayloadAction<ContratoTenant>) => {
        state.saving = false;
        state.contratos = state.contratos.map((c) =>
          c.id === action.payload.id ? action.payload : c,
        );
      })
      .addCase(suspenderContrato.rejected, (state, action) => {
        state.saving = false;
        state.error = (action.payload as string) ?? 'Erro ao suspender produto';
      })

      .addCase(reativarContrato.pending, (state) => {
        state.saving = true;
        state.error = null;
      })
      .addCase(reativarContrato.fulfilled, (state, action: PayloadAction<ContratoTenant>) => {
        state.saving = false;
        state.contratos = state.contratos.map((c) =>
          c.id === action.payload.id ? action.payload : c,
        );
      })
      .addCase(reativarContrato.rejected, (state, action) => {
        state.saving = false;
        state.error = (action.payload as string) ?? 'Erro ao reativar produto';
      })

      .addCase(encerrarContrato.pending, (state) => {
        state.saving = true;
        state.error = null;
      })
      .addCase(encerrarContrato.fulfilled, (state, action: PayloadAction<ContratoTenant>) => {
        state.saving = false;
        state.contratos = state.contratos.map((c) =>
          c.id === action.payload.id ? action.payload : c,
        );
      })
      .addCase(encerrarContrato.rejected, (state, action) => {
        state.saving = false;
        state.error = (action.payload as string) ?? 'Erro ao encerrar contrato';
      })

      .addCase(excluirContrato.pending, (state) => {
        state.saving = true;
        state.error = null;
      })
      .addCase(excluirContrato.fulfilled, (state, action: PayloadAction<string>) => {
        state.saving = false;
        state.contratos = state.contratos.filter((c) => c.id !== action.payload);
      })
      .addCase(excluirContrato.rejected, (state, action) => {
        state.saving = false;
        state.error = (action.payload as string) ?? 'Erro ao excluir contrato';
      });
  },
});

export const { clearError } = contratosTenantSlice.actions;
export const contratosTenantReducer = contratosTenantSlice.reducer;
